import React, { useEffect, useState } from "react";
import './Header.css';
import { NavLink, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

import Logo from '../Images/logo4.png';

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/About", label: "About" },
  { to: "/Services", label: "Services" },
  { to: "/Gym", label: "Gym" },
  { to: "/Testimonials", label: "Testimonials" },
  { to: "/FAQ", label: "FAQ" },
  { to: "/Contact", label: "Contact" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    // close the mobile menu whenever the route changes
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className={`Header ${scrolled ? "is-scrolled" : ""}`}>
      <div className="Header-inner">
        <NavLink to="/" className="brand" onClick={() => setMenuOpen(false)}>
          <img src={Logo} alt="Harteis Physical Therapy logo" className="Logo" />
        </NavLink>

        <button
          className="menu-toggle"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <FaTimes size={26} /> : <FaBars size={26} />}
        </button>

        <nav className={menuOpen ? "nav open" : "nav"}>
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {link.label}
            </NavLink>
          ))}
          <NavLink to="/Contact" className="nav-cta" onClick={() => setMenuOpen(false)}>
            Book a Visit
          </NavLink>
        </nav>

        <span className="header-spacer" aria-hidden="true" />
      </div>
    </header>
  );
}
